import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link, useRouteMatch } from 'react-router-dom';
import { useCompanyFeatures } from 'app/domains/companies/features/CompanyFeatures';
import { useWorkflowCheck } from '../WorkflowCheckProvider';
import { useWorkflowCheckOutdated } from '../useWorkflowCheckOutdated';
export function WorkflowCheckOutdatedMessage() {
    const { type, approvalWorkflows } = useWorkflowCheck();
    const { isApprovalOutdated, isSignatoryOutdated } = useWorkflowCheckOutdated();
    const { url } = useRouteMatch();
    const { isFeatureAvailable } = useCompanyFeatures();
    const isWorkflowsAvailable = isFeatureAvailable('DOCUMENT_ASSISTANT_WORKFLOWS');
    const isOutdated = type === 'approval' ? isApprovalOutdated : isSignatoryOutdated;
    const showApprovalLink = type === 'signatory' && isApprovalOutdated && approvalWorkflows.length > 0;
    const approvalUrl = url.replace('/esigning', '/approval');
    const approvalMessage = t({
        comment: 'Workflow check is outdated - Approval message',
        message: 'This document has been edited since the check for approval requirements was run. Please rerun the check.',
    });
    const signatoryMessage = t({
        comment: 'Workflow check is outdated - Signatory message',
        message: 'This document has been edited since the check for signatory requirements was run. Please rerun the check.',
    });
    const signatoryWithApprovalMessage = t({
        comment: 'Workflow check is outdated - Signatory with approval message',
        message: 'This document has been edited since the last rule check. Go to the Approval tab to run a new assessment.',
    });
    if (!isWorkflowsAvailable || !isOutdated) {
        return null;
    }
    return (<Box flexDirection="column" gap="md" p="lg" borderRadius="md" bg="background.100">
      <Box alignItems="center" gap="md">
        <Falcon icon="circle-info"/>
        <Typography $fontSize="small" $fontWeight="medium" $appearance="300" $lineHeight="neutralized">
          <Trans comment="Workflow check is outdated - Title">Document changed since last rule check</Trans>
        </Typography>
      </Box>
      {showApprovalLink ? (<Fragment>
          <Typography $fontSize="tiny" $appearance="200">
            {signatoryWithApprovalMessage}
          </Typography>
          <Button as={Link} to={approvalUrl} size="xs" appearance="primary">
            <Trans comment="Workflow check is outdated - Go to approval">Go to approval</Trans>
            <Falcon icon="arrow-right"/>
          </Button>
        </Fragment>) : (<Typography $fontSize="tiny" $appearance="200">
          {type === 'approval' ? approvalMessage : signatoryMessage}
        </Typography>)}
    </Box>);
}
